import { createSlice } from "@reduxjs/toolkit";
import cookieService from "./../services/CookieService";
import config from "../config";
import { getLogoutRedirectUrl } from "../utils/helpers";
import { clearAllCache } from "../utils/indexedDBCache";

const authSlice = createSlice({
    name: "auth",
    initialState: {
        user: null,
        token: null,
        returnUrl: null,
        deepLinkUrl: null,
        dlselectedIsfOrganizationId: [],
        dlViewId: null,
        dlDataView: null,
        enableSearchHyperlinks: false,
    },
    reducers: {
        login(state, action) {
            state.user = action.payload.user;
            state.token = action.payload.token;
        },
        setReturnUrl(state, action) {
            state.returnUrl = action.payload.returnUrl;
        },
        setDlUrlValues(state, action) {
            const { key, value } = action.payload;
            state[key] = value;
        },
        clearDlUrlValues(state) {
            state.dlselectedIsfOrganizationId = "";
            state.dlViewId = null;
            state.dlDataView = null;
        },
        setEnableSearchHyperlinks(state, action) {
            state.enableSearchHyperlinks = action.payload;
        },
        logout(state, _) {
            const redirectUrl = getLogoutRedirectUrl(
                state.user,
                state.returnUrl
            );

            state.token = null;
            state.returnUrl = null;
            state.enableSearchHyperlinks = false;

            const token = cookieService.get(config.REACT_APP_SSO_COOKIE_NAME);

            if (token) {
                cookieService.delete(config.REACT_APP_SSO_COOKIE_NAME);
            }

            // Clear all cached data when user logs out
            clearAllCache()
                .then(() => {
                    console.log("Cache cleared successfully on logout");
                })
                .catch((error) => {
                    console.error("Error clearing cache on logout:", error);
                })
                .finally(() => {
                    window.location = redirectUrl;
                });
        },
    },
});

export const { login, logout, setReturnUrl, setDlUrlValues, clearDlUrlValues, setEnableSearchHyperlinks } =
    authSlice.actions;

export default authSlice.reducer;
